import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Observable, timer} from 'rxjs';
import {take} from 'rxjs/operators';

@Component({
    selector: 'dk-message',
    template: require('./message.html'),
    inputs: ['text','type','messageId','autoHide','hideOnClick']
})

export class MessageComponent implements OnInit, AfterViewInit {
    myId: string;
    text: string;
    type: string = null;
    messageId: number = null;
    autoHide: boolean = true;
    isShown: boolean;

    hideOnClick: boolean = true;

    ngOnInit() {
        this.myId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        this.isShown = true;
        if (this.autoHide) {
            let timer$ = timer(5000, 0);

            timer$
                .pipe(take(1))
                .subscribe(t => {
                    this.isShown = false;
                });
        }
    }

    ngAfterViewInit() {
        if (this.myId) {
            document.getElementById(this.myId).scrollIntoView();
            window.scrollBy(0, -100);
        }
    }

    clicked() {
        if (this.hideOnClick) {
            this.isShown = false;
        }
    }
}
